import { MoreOutlined, FileTextOutlined, FileImageOutlined } from "@ant-design/icons";
import { FaRegFilePdf } from "react-icons/fa";
import { Checkbox, Dropdown } from 'antd';
import React from 'react'
import moment from "moment";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
import { useEffect } from "react";
import axios from "axios";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { PropertyHandlers } from "../../PropertyComp/state/actions";
import { Loading } from "../../Common";
import { listingContractTypes } from "../../Common/commondata/commonData";

const OtherDocsTable = ({ otherDocsData, handleOpenDoc, MenuItem, origin, listingItem, bos, agentDetails, delegate, isWeb, handleCheckboxChange, selectedItems }) => {
    const { propertyDocs, propertDocsLoading, propertDocsError } = useSelector((state) => state.PropertyReducer,shallowEqual);
    const dispatch = useDispatch();

    let unmounted = {
        value: false,
    };
    let sourceAxios = axios.CancelToken.source();

    useEffect(() => {
        if (origin === "PROPERTY_DOCS") {
            const params = {
                // ...(item?.offerId && !item.isSellingMatrix ? { offerId: item?.offerId } : {}),
                ...(listingItem?.isProperty ? { propertyId: listingItem?.propertyId } : {}),
                openFor: listingItem?.isProperty ? "SELLER_AGENT" : "BUYER_AGENT",
                ...(delegate ? { delegateSide: (listingItem?.isProperty) ? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id } : (bos && { delegateOwnerId: agentDetails?._id, screenType: "BOS" })),
                section: "PROPERTY_DOCS",
                // ...(isWeb ? { isWeb: true } : {}),
                queryPlatform: "WEB",
            };
            if (listingItem?.offerId || listingItem?.propertyId) {
                dispatch(PropertyHandlers.getPropertyDocsFun({ params, unmounted, source: sourceAxios }));
            }
            return () => {
                unmounted.value = true;
                sourceAxios.cancel("Cancelling in cleanup");
            }
        }
    }, [origin])

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "800px",
                padding: "0 20px",
                overflow: "auto",
                borderRadius: "8px",
            }}
        >
            {origin === "PROPERTY_DOCS" && propertDocsLoading ? <Loading/> : 
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "15px",
                }}
            >
                <thead>
                    <tr
                        style={{
                            borderBottom: "1px solid #ccc",
                            backgroundColor: "hsl(211deg 75% 48%)",
                            color: "white",
                        }}
                    >
                        <th style={{ textAlign: "center", padding: "10px" }}>File Name</th>
                        <th style={{ textAlign: "center", padding: "10px" }}>Creation Date</th>
                        <th style={{ textAlign: "center", padding: "10px" }}>{origin === "TOOLS" ? "Options" : "Select"}</th>
                    </tr>
                </thead>
                <tbody>
                    {(otherDocsData?.length > 0 && origin === "TOOLS" ? otherDocsData : propertyDocs?.filter((el) => !listingContractTypes.includes(el?.contractType)))?.map((item, index) => (
                        <tr
                            key={index}
                            style={{
                                borderBottom: "1px solid #eee",
                                backgroundColor: index % 2 === 0 ? "#fafafa" : "white", // subtle striping
                            }}
                        >
                            <td
                                style={{
                                    padding: "10px 5px 10px 30px",
                                    verticalAlign: "middle",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    handleOpenDoc(item);
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                    }}
                                >
                                    {item.fileType === "IMAGE" ? (
                                        <FileImageOutlined
                                            style={{
                                                color: "#ecd540",
                                                marginTop: "5px",
                                                marginRight: "5px",
                                                fontSize: "18px",
                                            }}
                                        />
                                    ) : item.fileType === "PDF" || item.isPdf || item.pdfLink ? (
                                        <FaRegFilePdf
                                            style={{
                                                color: "red",
                                                marginTop: "5px",
                                                marginRight: "5px",
                                                fontSize: "18px",
                                            }}
                                        />
                                    ) : (
                                        <FileTextOutlined style={{ color: "#74b3ed", fontSize: "18px" }} />
                                    )}
                                    <ContractTypeBadge contractType={item?.contractType} additionalStyle={{ fontSize: "12px" }} />
                                    <span
                                        style={{
                                            color: "blue",
                                            fontSize: "16px",
                                            maxWidth: "270px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            display: "inline-block",
                                        }}
                                    >
                                        {item?.updatedName || item?.documentName || item?.fileName}
                                        {item?.updatedName && (
                                            <>
                                                <br />
                                                <span style={{ fontSize: "14px" }}>
                                                    ({item?.documentName || item?.fileName})
                                                </span>
                                            </>
                                        )}
                                    </span>
                                </div>
                            </td>

                            <td style={{ textAlign: "center", padding: "10px" }}>
                                {origin === "TOOLS" ? item?.createdAt : item?.createdDateMili ? (
                                    <div>
                                        <div>{moment(origin === "PROPERTY_DOCS" ? item?.createdDateMili : item?.createdAt).format("MM/DD/YYYY")}</div>
                                        <div style={{ fontSize: "13px", color: "#777" }}>{moment(origin === "PROPERTY_DOCS" ? item?.createdDateMili : item?.createdAt).format("hh:mm A")}</div>
                                    </div>
                                ) : (
                                    "--"
                                )}
                            </td>
                            {origin === "TOOLS" ? <td style={{ textAlign: "center", padding: "10px" }}>
                                <Dropdown trigger={["click", "hover"]} overlay={<MenuItem item={item} />}>
                                    <MoreOutlined
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                            color: "#085190",
                                        }}
                                    />
                                </Dropdown>
                            </td> : <td>
                            <Checkbox
                                checked={selectedItems.some((i) => i._id === item._id)}
                                onChange={(e) => handleCheckboxChange(e.target.checked, item)}
                            />
                            </td>}
                        </tr>
                    ))}
                </tbody>
            </table>}
        </div>
    )
}

export default OtherDocsTable